import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import {
  IconCircleCheckFilled,
  IconCircle,
  IconChevronRight,
} from "@tabler/icons-react";
import { ActiveStep } from "@/components/POnboarding/onboarding-steps";

interface OnboardingStepRowProps {
  step: ActiveStep;
  justCompleted: boolean;
  /** Opens the step's detail overlay (also for completed steps). */
  onOpen: () => void;
}

export const OnboardingStepRow: React.FC<OnboardingStepRowProps> = ({
  step,
  justCompleted,
  onOpen,
}) => {
  const t = useTranslations("onboarding");

  return (
    <motion.div
      layout
      initial={false}
      animate={
        justCompleted
          ? {
              scale: [1, 1.02, 1],
              boxShadow: [
                "0 0 0 0 rgba(80, 168, 102, 0)",
                "0 0 0 6px rgba(80, 168, 102, 0.20)",
                "0 0 0 0 rgba(80, 168, 102, 0)",
              ],
              opacity: 1,
            }
          : { scale: 1, boxShadow: "0 0 0 0 rgba(80, 168, 102, 0)", opacity: 1 }
      }
      transition={{ duration: 0.7, ease: "easeOut" }}
      className="rounded-lg"
    >
      <button
        type="button"
        onClick={onOpen}
        className="group w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg transition-colors text-left hover:surface-tertiary cursor-pointer"
      >
        <span className="shrink-0 w-[18px] h-[18px]">
          {step.isCompleted ? (
            <IconCircleCheckFilled size={18} className="font-success" />
          ) : (
            <IconCircle size={18} className="font-tertiary" />
          )}
        </span>
        <span
          className={`flex-1 min-w-0 body-3-medium truncate ${
            step.isCompleted ? "font-tertiary" : "font-primary"
          }`}
        >
          {t(step.titleKey)}
        </span>
        <IconChevronRight
          size={14}
          className="font-tertiary shrink-0 opacity-0 group-hover:opacity-100 transition-opacity"
        />
      </button>
    </motion.div>
  );
};
